import React, { FC } from 'react'
import HeaderPrivate from 'src/components/Header/Private'
import useGetProfile from 'src/hooks/useGetProfile'

interface Props {
  children: React.ReactNode
}

const PlatformLayout: FC<Props> = ({ children }) => {
  useGetProfile()

  return (
    <>
      <HeaderPrivate />
      <main>{children}</main>
    </>
  )
}

export default PlatformLayout
